import type { Prototype } from "../prototype-types";

export const ireneMaPrototypes: Prototype[] = [
  {
    id: "im-product-polls",
    name: "Product Polls",
    path: "/im/product-polls",
    description: "Brands run polls to get retailer feedback on prospective products.",
    project: "Demand signals for brands",
    owner: "Irene Ma",
    createdAt: "2026-05-16",
    lastUpdated: "2026-05-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/137795f8a87ab8f94b0035689441a2ee43dab0d61b290b4632b7db2260641da7.png",
    creationTool: "claude-code",
  },
  {
    id: "im-product-request",
    name: "Product Request — Brand",
    path: "/im/product-request",
    description: "Request for products that brands are not selling on Faire.",
    project: "Demand Signals",
    owner: "Irene Ma",
    createdAt: "2026-05-16",
    lastUpdated: "2026-05-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/b8244164c1e1bd26a5c5d16bb557e7677472944ddd7cab53f17a13d9f9544a91.png",
    creationTool: "claude-code",
  },
  {
    id: "im-waitlist",
    name: "Waitlist — Brand",
    path: "/im/waitlist",
    description: "A &quot;Waitlist&quot; section on the Products tab of the brand portal.",
    project: "Demand signals for brands",
    owner: "Irene Ma",
    createdAt: "2026-05-15",
    lastUpdated: "2026-05-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/84864227c1fbd7ff76b4056d526b50fdd9003d04ff4ba812ee95d107a55d518f.png",
    creationTool: "claude-code",
  },
  {
    id: "im-product-request-retailer",
    name: "Product Request",
    path: "/im/product-request-retailer",
    description: "Surfaces products brands sell elsewhere but haven&#39;t listed on Faire, letting retailers request them with a desired quantity",
    owner: "Irene Ma",
    createdAt: "2026-05-27",
    lastUpdated: "2026-05-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/83cf833518fd9e94597a068891aaa891f3430e3e337bb8b220b4da1e2d6bb373.png",
    creationTool: "claude-code",
  },
  {
    id: "im-waitlist-retailer",
    name: "Waitlist",
    path: "/im/waitlist-retailer",
    description: "Retailer waitlist for coming-soon products",
    owner: "Irene Ma",
    createdAt: "2026-05-27",
    lastUpdated: "2026-05-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/c544441eeb6b13def0c605928d4daadad39c7c338ea43998ca0d7d7a09886a4f.png",
    creationTool: "claude-code",
  }
];
